import { WarningFilled } from '@ant-design/icons';
import Alert from 'antd/lib/alert';
import Flex from 'antd/lib/flex';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '@/reducers/reducers';
import { selectAppSettings } from '@/selectors/selectors';
import { createAppSettingsRouteWithSettingType, createWorkflowStepSettingsRoute } from '@/helpers/routeHelpers';
import { SettingType } from '@/types';
import { runwayColors } from './styles/globalStyles';

interface AgeRatingWarningProps {
    orgId: string;
    appId: string;
    stepConfigId?: string;
}

const AgeRatingWarning: React.FC<AgeRatingWarningProps> = ({ orgId, appId, stepConfigId }) => {
    const isWhiteLabel = useSelector((state: RootState) => selectAppSettings(state, appId)?.isWhiteLabel === true);
    const settingsDestination =
        isWhiteLabel ?
            <Link to={createAppSettingsRouteWithSettingType(orgId, appId, SettingType.AppStore)}>
                App Store defaults
            </Link>
        : stepConfigId ?
            <>
                <Link to={createWorkflowStepSettingsRoute(orgId, appId, stepConfigId)}>Submission</Link> step settings
            </>
        :   'Submission step settings';

    return (
        <Alert
            closable={false}
            type="warning"
            message={
                <Flex vertical>
                    <Space align="start">
                        <WarningFilled style={{ color: runwayColors.statusYellow, marginTop: 4 }} />
                        <Text>
                            Some age rating answers are missing in App Store Connect, and may be required to submit. Set
                            answers in {settingsDestination}.
                        </Text>
                    </Space>
                </Flex>
            }
            style={{ fontSize: 12, padding: '6px 12px', display: 'inline-flex' }}
        />
    );
};

export default AgeRatingWarning;
